import cn from "classnames";
import { Typography } from "@mui/material";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { useRouter } from "next/router";

import { BrowserHooks, ProviderHooks } from "@/src/hook";
import type { StrapiComponentType, StrapiType } from "@/src/type";

import styles from "./SimpleLink.module.scss";

function checkIfShouldTurnOff(pathname?: string, searchParams?: string, domain?: string, hideOnSearchParams?: StrapiType.StrapiTags): boolean {
  if (!hideOnSearchParams) {
    return true;
  }

  try {
    const __searchParams = new URLSearchParams(searchParams ?? "");
    for (const opt of hideOnSearchParams ?? []) {
      const domainWithPath = `https://${domain ?? ""}/${pathname ?? ""}`;
      if (__searchParams.toString().includes(opt.name) || (domainWithPath ?? "").includes(opt.name)) {
        return false;
      }
    }
  } catch (err) {}

  return true;
}

interface SimpleLinkProps {
  navItem: StrapiComponentType.Element.Link;
  closeDrawer: () => void;
  fontSize?: string | number;
  center?: boolean;
}

function SimpleLink({ navItem, closeDrawer, fontSize, center }: SimpleLinkProps) {
  const cms = ProviderHooks.useCMS();
  const app = ProviderHooks.useApp();
  const pathname = usePathname();
  const router = useRouter();
  const externalLink = BrowserHooks.useLinkWithTrackingParams(navItem.href ?? "", true);

  const handleClick = (e: any, href: string) => {
    if (router.asPath === href) {
      e.preventDefault();
      closeDrawer();
      return;
    }
    router.push(href);
    closeDrawer();
  };

  const show = checkIfShouldTurnOff(pathname ?? "", app.defaultQuery, app.defaultDomain, navItem.hideOnSearchParams);
  if (!show) {
    return <></>;
  }

  return (
    <Link
      href={navItem.isExternal ? externalLink : cms.constructLink(navItem.href)}
      className={cn(styles.simpleLink, center ? styles.center : undefined)}
      target={navItem.target}
      onClick={(e) => handleClick(e, navItem.isExternal ? navItem.href : cms.constructLink(navItem.href))}
      prefetch={false}
    >
      <Typography
        variant="body1"
        lineHeight={fontSize ?? "18px"}
        fontSize={fontSize ?? "18px"}
      >
        {navItem.label}
      </Typography>
    </Link>
  );
}

export default SimpleLink;
